// src/utils/errorDetection.js
import { COMMON_ISSUES } from './commonIssues';

export const detectError = (code) => {
  try {
    // 実際にコードを実行してエラーをキャッチ
    new Function(code)();
    return null;
  } catch (error) {
    return {
      message: error.message,
      type: error.name,
      line: error.line || null
    };
  }
};

export const analyzeError = (error) => {
  if (!error) return null;

  for (const [key, issue] of Object.entries(COMMON_ISSUES)) {
    if (issue.patterns.some(pattern => error.message.includes(pattern))) {
      return {
        type: key,
        guidance: issue.guidance,
        tips: issue.tips,
        originalError: error
      };
    }
  }

  return {
    type: 'unknown',
    guidance: '一般的なエラーです。エラーメッセージを注意深く読んでみましょう。',
    tips: ['エラーメッセージをGoogle検索してみる'],
    originalError: error
  };
};